import React from 'react';
import classnames from 'classnames';
import './Breadcrumbs.scss';

interface LinkProps {
  title: string;
  url: string;
}

interface BreadcrumbsProps {
  list: Array<LinkProps>;
  actualPage: string;
}

export default function Breadcrumbs({ list, actualPage }: BreadcrumbsProps): React.ReactElement {
  return (
    <section className="breadcrumbs">
      {list.map((breadcrumb, index) => {
        return (
          <a
            className={classnames('breadcrumbs__link', {
              'breadcrumbs__link--selected': actualPage === breadcrumb.title,
            })}
            href={breadcrumb.url}
            key={breadcrumb.title + ' ' + breadcrumb.url}
          >
            {breadcrumb.title} <span>{index !== list.length - 1 && '/'} </span>
          </a>
        );
      })}
    </section>
  );
}
